{
    "Profile_Summary_Action.package_policy": "This is a package policy.",
    "Profile_Summary_Action.update_underlier": "To make changes, update the underlier policies in the package directly.",
    "Profile_Summary_Action.auto": "Auto",
    "Profile_Summary_Action.home": "Home",
    "Profile_Summary_Action.summary": "Summary",
    "Profile_Summary_Action.part_of_package": "This policy is part of a package.",
    "Profile_Summary_Action.renew_master": "To renew this policy, trigger the renewal on the master policy.",
    "Profile_Summary_Action.home_and_auto": "Home & Auto",

    "Profile_Summary_Action.policyStarts": "Policy starts {date}",
    "Profile_Summary_Action.policyEnds": "Policy ends {date}",
    "Profile_Summary_Action.quoteExpires": "Quote expires {date}",
    "Profile_Summary_Action.policyNumber": "Policy Number: {number}",
    "Profile_Summary_Action.binderNumber": "Binder Number: {number}",
    "Profile_Summary_Action.selectedInsurer": "Selected Insurer: {insurer}",
    "Profile_Summary_Action.pleaseContact": "Please {contact} for more information",
    "Profile_Summary_Action.contact": "contact us",

    "Profile_Summary_Action.summary_header": "Summary",
    "Profile_Summary_Action.quote_reference": "Quote Reference",
    "Profile_Summary_Action.premium": "Premium",
    "Profile_Summary_Action.surcharges_total": "Surcharges",
    "Profile_Summary_Action.discount_total": "Discounts",
    "Profile_Summary_Action.fees": "Fees",
    "Profile_Summary_Action.subtotal": "SubTotal",
    "Profile_Summary_Action.taxes": "Taxes",
    "Profile_Summary_Action.total": "Total",

    "Profile_Summary_Action.discounts": "Discounts",
    "Profile_Summary_Action.surcharges": "Surcharges",

    "Profile_Summary_Action.incomplete": "Incomplete",
    "Profile_Summary_Action.submitted": "Submitted",
    "Profile_Summary_Action.accepted": "Accepted",
    "Profile_Summary_Action.rejected": "Rejected",
    "Profile_Summary_Action.declined": "Declined",
    "Profile_Summary_Action.referred": "Referred",
    "Profile_Summary_Action.underwritingRequired": "Underwriting Required",
    "Profile_Summary_Action.cancelled": "Policy Cancelled",
    "Profile_Summary_Action.deleted": "Deleted",
    "Profile_Summary_Action.quoted": "Quoted",
    "Profile_Summary_Action.quoteIssued": "Quote Issued",
    "Profile_Summary_Action.quoteAccepted": "Quote Accepted",
    "Profile_Summary_Action.lost": "Lost",
    "Profile_Summary_Action.abandoned": "Abandoned",
    "Profile_Summary_Action.bindRequested": "Bind Requested",
    "Profile_Summary_Action.bound": "Bound",
    "Profile_Summary_Action.issued": "Issued",
    "Profile_Summary_Action.quoting": "Quote In Progress",

    "Profile_Summary_Action.brokerage": "Brokerage: {text}",
    "Profile_Summary_Action.assignedTo": "Assigned To: {text}"
}
